<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @del="delall" @save="sava"
                    @exps="exp" @imp="imp" ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <!-- <el-button @click="refreshView" size="mini" type="primary">{{$t('getapi[6411]')}}</el-button> -->
                <!-- 表格 -->
                <wTable
                        id="xpane-0"
                        :data="datajson"
                        :loading="loading"
                        queryData="ECRViewInfo"
                        :filter_language="['ecr_status','new_flag','ecr_urgency']"
                        :filter_date="['create_time']"
                        :header="tableHeader"
                        :option="tableOption"
                        :row-class-name="tableRowClassName"
                        @edits="edits"
                        @rowdblclick="openEdit"
                        :checkflg="false"
                        ref="singleTable"
                        style="margin-top: 2px"
                ></wTable>
                <!-- 表格 -->
            </li>

            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="width:1120px;min-width: 1120px;overflow:auto">
                    <table>
                        <tr>
                            <td style="width:60px;min-width: 60px"><span>ECR NO</span></td>
                            <td style="width:340px;min-width:340px">
                                <el-select style="width: 80px;" v-model="ecnno" :disabled="Master.ecr_status != 0">
                                    <el-option v-for="(item, index) in ecnnolist" :key="index" :value="item.items"
                                               :label="item.items"></el-option>
                                </el-select>
                                -ECR-
                                <el-input v-if="Master.ecr_status == 0" style="width: 100px;" v-model="ecnno1"
                                          @click.native.prevent="showsal" class="mcolor" readonly></el-input>
                                <el-input v-if="Master.ecr_status != 0" style="width: 100px;" v-model="ecnno1"
                                          readonly></el-input>
                                -
                                <el-input style="width: 100px;" v-model="ecnno2" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:100px;min-width:100px"><span>{{ $t('getapi[112]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input
                                        v-model="Master.part_code"
                                        :placeholder="$t('getapi[112]')"
                                        style="width: 130px;"
                                        size="mini"
                                        @click.native.prevent="showitem"
                                        class="mcolor"
                                        readonly
                                        v-if="Master.ecr_status == 0"
                                ></el-input>
                                <el-input v-if="Master.ecr_status != 0" style="width: 130px;" v-model="Master.part_code"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[149]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input
                                        v-model="Master.part_version"
                                        :placeholder="$t('getapi[149]')"
                                        style="width: 115px;"
                                        size="mini"
                                        @click.native.prevent="showitem"
                                        class="mcolor"
                                        readonly
                                ></el-input>
                            </td>
                            <td><span>{{$t('getapi[6700]')}}</span></td>
                            <td>
                                <el-input
                                        v-model="Master.itemvernum"
                                        :placeholder="$t('getapi[6700]')"
                                        style="width: 115px;"
                                        size="mini"
                                ></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{$t('getapi[6134]')}}</span></td>
                            <td>
                                <el-input v-model="Master.client_name" :readonly="true" class="readO" size="mini"></el-input>
                            </td>
                            <td><span>{{$t('getapi[13048]')}}</span></td>
                            <td><el-input v-model="Master.product_name" size="mini"></el-input></td>
                            <td><span>{{$t('getapi[13049]')}}</span></td>
                            <td><el-input v-model="Master.client_ecr_no" size="mini"></el-input></td>
                            <td style="width:60px;min-width:60px"><span>{{$t('getapi[6149]')}}</span></td>
                            <td style="width:120px;min-width:120px"><el-input v-model="Master.client_confirm" size="mini"></el-input></td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[13046]')}}</span>
                                <td style="width:300px;min-width:300px"> 
                                <el-select style="width: 100px;" v-model="Master.ecr_source">
                                    <el-option value="0" :label="$t('getapi[8716]')"></el-option>
                                    <el-option value="1" :label="$t('getapi[8717]')"></el-option>
                                </el-select>
                                <span>{{$t('getapi[13047]')}}</span>
                                <el-select style="width: 185px;" v-model="Master.ecr_type_code">
                                    <el-option v-for="(item, index) in ecntypelist" :key="index" :value="item.ECN_Type_Code"
                                               :label="item.ECN_Type_Name"></el-option>
                                </el-select>
                            </td>
                            <td><span>{{$t('getapi[6150]')}}</span></td>
                            <td style="width:150px;min-width:150px">
                                    <el-select style="width: 150px;" v-model="Master.product_stage_code">
                                    <el-option v-for="(item, index) in ecnstagelist" :key="index"
                                               :value="item.Product_Stage_Code" :label="item.Product_Stage_Name"></el-option>
                                </el-select>
                            </td>
                            <td><span>{{$t('getapi[6138]')}}</span></td>
                            <td style="width:100px;min-width:100px">
                                <el-select  v-model="Master.ecr_urgency">
                                    <el-option v-for="(item, index) in ugenry" :key="index" :value="item.id"
                                               :label="item.name"></el-option>
                                </el-select>
                            </td>
                            <td><span>{{$t('getapi[552]')}}</span></td>
                            <td style="width:100px;min-width:100px">
                                
                                <el-input v-if="Master.ecr_status == 0" :value="$t('getapi[1422]')" 
                                          :readonly="true" class="readO" size="mini"></el-input>
                                <el-input v-if="Master.ecr_status == 1" :value="$t('getapi[8718]')" 
                                          :readonly="true" class="readO" size="mini"></el-input>
                                <el-input v-if="Master.ecr_status == 2" :value="$t('getapi[5141]')" 
                                          :readonly="true" class="readO" size="mini"></el-input>
                                <el-input v-if="Master.ecr_status == 3" :value="$t('getapi[2408]')" 
                                          :readonly="true" class="readO" size="mini"></el-input>
                                <el-input v-if="Master.ecr_status == 4" :value="$t('getapi[8719]')"
                                          :readonly="true" class="readO" size="mini"></el-input>
                                <el-input v-if="Master.ecr_status == 5" :value="$t('getapi[5142]')" 
                                          :readonly="true" class="readO" size="mini"></el-input>
                                <el-input v-if="Master.ecr_status == 6" :value="$t('getapi[5143]')" 
                                          :readonly="true" class="readO" size="mini"></el-input>
                                <el-input v-if="Master.ecr_status == 7" :value="$t('getapi[441]')"
                                          :readonly="true" class="readO" size="mini"></el-input>
                            </td>
                            
                        </tr>
                        <tr>
                            <td colspan="2" style="white-space: nowrap">
                                <span>{{$t('getapi[6151]')}}</span>
                                <el-input type="number" @mousewheel.native.prevent v-model="Master.annex_drawing_num" style="width: 60px;"
                                          size="mini"></el-input>
                                {{$t('getapi[6152]')}}
                                <span>WI</span>
                                <el-input type="number" @mousewheel.native.prevent v-model="Master.annex_wi_num" style="width: 60px;"
                                          size="mini"></el-input>
                                {{$t('getapi[6152]')}}
                                <span>{{$t('getapi[224]')}}</span>
                                <el-input type="number" @mousewheel.native.prevent v-model="Master.annex_other_num" style="width: 60px;"
                                          size="mini"></el-input>
                                {{$t('getapi[6152]')}}
                                <el-button type="danger" size="mini" style="margin-left: 15px;" @click="closeqz"
                                           :disabled="!btn.colse">{{$t('getapi[2345]')}}
                                </el-button>
                            </td>
                            <td colspan="2">
                                <el-checkbox v-model="Master.new_flag" :true-label="'1'" :false-label="'0'">
                                    {{$t('getapi[6147]')}}
                                </el-checkbox>
                            </td>
                            <td><span>{{$t('getapi[6153]')}}</span></td>
                            <td>
                                <el-input v-model="Master.ecr_accept_person"
                                          @click.native.prevent="showgetpe(0)" readonly></el-input>
                            </td>
                            <td><span>{{$t('getapi[6154]')}}</span></td>
                            <td>
                                <el-date-picker
                                        v-model="Master.ecr_accept_time"
                                        type="date"
                                        value-format="yyyy/MM/dd HH:hh:ss"
                                        size="mini"
                                        style="width:100%"
                                ></el-date-picker>
                            </td>
                        </tr>
                        <tr>
                            
                            <td>{{$t('getapi[6140]')}}</td>
                            
                             <td>  <el-input v-model="Master.create_person" style="width: 130px;"
                                            size="mini"></el-input>
                            {{$t('getapi[6141]')}}
                           
                                <el-date-picker
                                        v-model="Master.create_time"
                                        type="date"
                                        value-format="yyyy/MM/dd HH:hh:ss"
                                        style="width: 130px;"
                                        size="mini"
                                        :disabled="true"
                                ></el-date-picker>
                                </td>
                                <td>
                                <el-button
                                        v-if="Master.ecr_status == 0 && ((Master.create_person.indexOf(user) >= 0)) && Master.ecr_no"
                                        size="mini"
                                        type="danger"
                                        style="margin-left: 15px;"
                                        @click="savas(1)"
                                >
                                    {{$t('getapi[6176]')}}
                                </el-button>
                                <el-button v-else size="mini" type="danger" style="margin-left: 15px;" disabled>
                                    {{$t('getapi[6176]')}}
                                </el-button>
                            </td>
                        </tr>
                    </table>
                </div>
                {{$t('getapi[6155]')}}：{{ Master.RoutingStr }}
                <el-tabs>
                    <el-tab-pane :label="$t('getapi[13044]')">
                        <quillEditor class='quillEditorChild' ref='myQuillEditor' v-model="Master.ecr_description"
                                   @inputChange="onEditorChange($event)"
                                  :disabled="Master.ecr_status >= 3"
                                  :style="{height:tableHeight -150+ 'px'}"> </quillEditor>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[13045]')">
                        <div class="btnnowrap">
                            <el-button type="primary" v-if="IsLoginDB_MY=='my'" :disabled="!btn.delsign" @click="addSign('')" size="mini" >{{ $t('getapi[12841]') }}</el-button>
                            <el-button type="primary" v-if="IsLoginDB_MY=='my'" size="mini" :disabled="!btn.delsign" @click="delline" >{{$t('getapi[4097]') }}</el-button>
                        </div>
                        <!-- 表格 -->
                        <el-table
                                :data="ecnper"
                                v-loading="loading"
                                :highlight-current-row="false"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - 215"
                                tab-click="selectInfo(0)"
                                header-row-class-name="headerclass"
                                @selection-change="handleSelectionChange_Ecnper"
                                style="width: 100%; margin-top:0px"
                                :header-cell-style="$limits.headerClass"
                                
                        >
                            <el-table-column type="selection" align="center" width="20"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="signature_strategy_no" label="ID"
                                             v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="role_name"
                                             :label="$t('getapi[6179]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="user_name"
                                             :label="$t('getapi[1191]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="opinion"
                                             :label="$t('getapi[6180]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="opinion_time"
                                             :label="$t('getapi[6181]')"></el-table-column>
                            <el-table-column prop="opinion_status" :label="$t('getapi[552]')">
                                <template slot-scope="scope">
                                    <el-input v-show="scope.row.opinion_status == -1" :value="$t('getapi[8724]')" disabled></el-input>
                                    <el-input v-show="scope.row.opinion_status == 0" :value="$t('getapi[6188]')" disabled></el-input>
                                    <el-input v-show="scope.row.opinion_status == 1" :value="$t('getapi[6187]')" disabled></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('getapi[6048]')" width="70" align="center">
                                <template slot-scope="scope">
                                    <!-- v-if="Master.ecr_status == 4" -->
                                    <el-button v-if="Master.ecr_status == 1"  @click.native.prevent="hq(scope)"
                                               type="text" size="small" :disabled="scope.row.superior_flag == 0">
                                        {{$t('getapi[6048]')}}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 表格 -->
                    </el-tab-pane>
                </el-tabs>
            </li>
        </ul>
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="16">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="SelectIndexs"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="PageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="8">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->
        <!-- 搜索弹框 -->
        <serce :isVisible="isVisible" queryData="ECRViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6125]')" queryData="ECRViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!-- 搜索弹框 -->
        <!-- 客户弹框 -->
        <selector :isVisible="false" :selectType="2" :isSplitPage="true" :postUrl="'Basic/Popup/GetSALCustomerDataList'"
                  @callback="getsal" ref="setsal"></selector>
        <!-- 头物料弹框 -->
        <selector :isVisible="false" :selectType="13" :isSplitPage="true" :postUrl="'Basic/Popup/GetPartPopuDataList'"
                  @callback="getitem" ref="setitem"></selector>
        <selector :isVisible="false" :selectType="13" :isSplitPage="true" :postUrl="'Basic/Popup/GetPartPopuDataList'"
                  @callback="getitems" ref="setitems"></selector>
        <!-- 头接受人 -->
        <selector :isVisible="false" :selectType="8" :isSplitPage="true" :postUrl="'Basic/Popup/GetEmployeeDataList'"
                  @callback="getper" ref="setper"></selector>
        <!-- ecn实施计划负责人 -->
        <selector :isVisible="false" :selectType="8" :isSplitPage="true" :postUrl="'Basic/Popup/GetEmployeeDataList'"
                  @callback="getpers" ref="setpers"></selector>
        <!-- 审核人 批准人 -->
        <selector :isVisible="false" :selectType="8" :isSplitPage="true" :postUrl="'Basic/Popup/GetEmployeeDataList'"
                  @callback="getEmployee" ref="employee"></selector>
        <!-- 分发部门 -->
        <selector :isVisible="false" :selectType="8" :isSplitPage="true" :postUrl="'Basic/Popup/GetEmployeeDataList'"
                  @callback="getperss" ref="setperss"></selector>
        <!-- 会签人员 -->
        <selector :isVisible="signVisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/Basic/ECN/GetECNSignatureStrategyPopuDataList'" @callback="getSignlist" ref="setsignlist"></selector>
        <!-- 添加物料 -->
        <selector :isVisible="partVisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/Eng/ECN/GetEcnPartMasterPopupList'" @callback="getPartlist" ref="setpartlist"></selector>
        <!-- 会签弹框 -->
        <el-dialog v-dialogDrag center :title="$t('getapi[6186]')" :visible.sync="dialogVisible" width="30%">
            <el-input v-model="sign.opinion" type="textarea" :rows="5" show-word-limit></el-input>
            <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="hqbtn(0)">{{$t('getapi[6187]')}}</el-button>
				<el-button type="warning" @click="hqbtn(1)">{{$t('getapi[6188]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isShowDialog" :title="$t('getapi[8126]')" width="25%" :close-on-click-modal="false">
            <el-input type="textarea" v-model="RejectStr1" rows="22" v-if="RejectType == 1"></el-input>
            <el-input type="textarea" v-model="RejectStr2" rows="22" v-if="RejectType == 2"></el-input>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowDialog = false">{{ $t('getapi[2054]') }}</el-button>
                <el-button type="primary" size="mini" @click="confirmReject(1)" v-if="RejectType == 1">{{ $t('getapi[937]') }}</el-button>
                <el-button type="primary" size="mini" @click="confirmReject(2)" v-if="RejectType == 2">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        
        <el-dialog v-dialogDrag :visible.sync="isVisiblefile" :title="$t('getapi[6225]')" width="50%">
            <div style="display: flex">
                <el-upload :show-file-list="false" class="upload-demo"
                           :data="fileparm"
                           :action="fileurl"
                           :on-change="handleChange"
                           :on-success="handleSuccess">
                    <el-button size="mini" type="primary">{{$t('getapi[3591]')}}</el-button>
                </el-upload>
                <!-- <el-button size="mini" type="primary" @click="addline" style="margin-left: 8px">{{$t('getapi[878]')}}</el-button>
                <el-button size="mini" type="primary" @click="batchdel" :disabled="selectData.length < 1">{{$t('getapi[40]')}}</el-button> -->
            </div>
            <el-table :data="FileLists" border height="400" size="mini" style="width: 100%;"
                      header-row-class-name="headerclass"
                      @selection-change="handleSelectionChange"
                      :row-class-name="tableRowClassName">
                <!-- <el-table-column type="selection"></el-table-column> -->
                <el-table-column show-overflow-tooltip prop="filename" :label="$t('getapi[3590]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="doc_type" :label="$t('getapi[3605]')" width="80"></el-table-column>
                <el-table-column show-overflow-tooltip prop="doc_size" :label="$t('getapi[7875]')" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="upload_person" :label="$t('getapi[6425]')" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="upload_time" :label="$t('getapi[6426]')" width="130"></el-table-column>
                <el-table-column show-overflow-tooltip prop="path" :label="$t('getapi[7952]')" width="100"></el-table-column>
                <el-table-column align="center" :label="$t('getapi[6048]')" width="100">
                    <template slot-scope="scope">
                        <el-button slot="reference" type="text" size="small"  @click.native.prevent="lookfiles(scope)">{{$t('getapi[3558]')}}</el-button>
                        <el-button slot="reference" type="text" size="small" v-if="scope.row.upload_person==user"  @click.native.prevent="filedel(scope)">{{$t('getapi[40]')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isVisiblefile = false">{{$t('getapi[441]')}}</el-button>
				<!-- <el-button type="primary" @click="saveFile">{{$t('getapi[937]')}}</el-button> -->
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import Quill from 'quill';
    import {quillEditor} from 'vue-quill-editor';
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    import {container, ImageExtend} from 'quill-image-extend-module';
    import { Loading } from 'element-ui';    
    Quill.register('modules/ImageExtend', ImageExtend);
    import quillConfig from '@/utils/config.js';
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'

    export default {
        name: 'ecrlist',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                /* 富文本参考网站:https://blog.csdn.net/weixin_43888129/article/details/103888623 */
                quillOption: quillConfig,
                isedit: 1,
                dialogVisible: false, //会签谈框
                sign: {
                    relation_ecr_no: '',
                    relation_signature_strategy_no: '',
                    opinion_person: '',
                    opinion: '',
                    opinion_time: '',
                    role_name: '',
                    user_name: '',
                    opinion_status: 0,
                    superior_flag: 0
                },
                Type: 0,
                SignList: [],
                PartLists:[],
                Master: {
                    ecr_no: '',
                    part_code: '',
                    part_version: '',
                    ecr_status: '0',
                    ecr_source: '',
                    client_name: '',
                    product_name: '',
                    client_ecr_no: '',
                    ecr_type_code: '',
                    product_stage_code: '',
                    ecr_urgency: '',
                    ecr_description: '',
                    ecr_accept_time: null,
                    ecr_accept_person: '',
                    client_confirm: '',
                    annex_drawing_num: '',
                    annex_wi_num: '',
                    annex_other_num: '',
                    plate_part_code_1: '',
                    plate_part_version_1: '',
                    plate_onway_num_1: '',
                    plate_stock_num_1: '',
                    plate_deal_with_1: '',
                    plate_price_1: '',
                    plate_mold_cost_1: '',
                    plate_amount_1: '',
                    plate_bear_1: '',
                    plate_part_code_2: '',
                    plate_part_version_2: '',
                    plate_onway_num_2: '',
                    plate_stock_num_2: '',
                    plate_deal_with_2: '',
                    plate_price_2: '',
                    plate_mold_cost_2: '',
                    plate_amount_2: '',
                    plate_bear_2: '',
                    plate_part_code_3: '',
                    plate_part_version_3: '',
                    plate_onway_num_3: '',
                    plate_stock_num_3: '',
                    plate_deal_with_3: '',
                    plate_price_3: '',
                    plate_mold_cost_3: '',
                    plate_amount_3: '',
                    plate_bear_3: '',
                    procurement_part_code_1: '',
                    procurement_part_version_1: '',
                    procurement_onway_num_1: '',
                    procurement_stock_num_1: '',
                    procurement_deal_with_1: '',
                    procurement_price_1: '',
                    procurement_mold_cost_1: '',
                    procurement_amount_1: '',
                    procurement_bear_1: '',
                    procurement_part_code_2: '',
                    procurement_part_version_2: '',
                    procurement_onway_num_2: '',
                    procurement_stock_num_2: '',
                    procurement_deal_with_2: '',
                    procurement_price_2: '',
                    procurement_mold_cost_2: '',
                    procurement_amount_2: '',
                    procurement_bear_2: '',
                    procurement_part_code_3: '',
                    procurement_part_version_3: '',
                    procurement_onway_num_3: '',
                    procurement_stock_num_3: '',
                    procurement_deal_with_3: '',
                    procurement_price_3: '',
                    procurement_mold_cost_3: '',
                    procurement_amount_3: '',
                    procurement_bear_3: '',
                    making_onway_num: '',
                    making_stock_num: '',
                    making_deal_with: '',
                    making_price: '',
                    making_mold_cost: '',
                    making_amount: '',
                    making_bear: '',
                    product_onway_num: '',
                    product_stock_num: '',
                    product_deal_with: '',
                    product_price: '',
                    product_mold_cost: '',
                    product_amount: '',
                    product_bear: '',
                    planner: '',
                    planner_remark: '',
                    planner_affirm: '',
                    original_price: '',
                    current_price: '',
                    client_accept: '',
                    client_accept_time: null,
                    create_person: '',
                    create_time: null,
                    audit_person: '',
                    audit_time: null,
                    confirm_person: '',
                    confirm_time: null,
                    ecr_produce_person: '',
                    ecr_produce_time: '',
                    ecr_purchase_person: '',
                    ecr_purchase_time: null,
                    ecr_notes: '',
                    department: '',
                    ecr_close_time: null,
                    ecr_close_person: this.user,
                    modify_person: '',
                    modify_time: new Date(),
                    plate_deal_with_1_0: '',
                    plate_deal_with_2_0: '',
                    plate_deal_with_3_0: '',
                    procurement_deal_with_1_0: '',
                    procurement_deal_with_2_0: '',
                    procurement_deal_with_3_0: '',
                    making_deal_with_0: '',
                    product_deal_with_0: '',
                    routingstr: '',
                    new_flag: '',
                    itemvernum: '',
                    rejectstr1: '',
                    rejectstr2: ''
                },
                ecnno: '',
                ecnno1: '',
                ecnno2: '',
                ids: '',
                rowindx: 0, //ecn实施计划负责人弹框下标
                showloading: '',
                isVisible: false,
                editvisi: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('ecnlist'),
                SelectIndex: 0,
                SelectIndexs: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight3,
                isShowEdit: false, // 是否显示编辑页面
                dataSetDetail: {}, // 编辑页面数据详情
                queryData: [], // 查询数组
                selectIDData: [], // 右侧选择的数据的ID集合
                tracetype: 0, //跟踪类别
                url: '', // 零件图路径
                //isedit: true, // 是否新增
                itevisible: false, //物料弹框
                rouvisible: false,
                roushowindex: 0,
                wcentervisible: false,
                wcentershowindex: 0,
                editf: true,
                currentRow: null,
                lineid: [],
                userData: [], //用户信息
                user: '', //当前用户
                SuperiorName: '', //ecn有权限实施人员
                btn: {
                    //明细行删除
                    rowdel: false,
                    colse: false,
                    implement: false, // 是否可以实施
                    delsign:false,//删除会签人员
                    delpart:false,//删除物料
                },
                canmove: true, //可以流转
                ecnitem: [], //实施条目
                ecndep: [], //分发部门
                ecnper: [], //会签人员
                ecnnolist: [], //ecnno
                ecntypelist: [],
                ecnstagelist: [],
                proyx: [
                    {
                        name: '特殊板材1',
                        plate_part_code: '',
                        plate_part_version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    },
                    {
                        name: '特殊板材2',
                        plate_part_code: '',
                        plate_part_version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    },
                    {
                        name: '特殊板材3',
                        plate_part_code: '',
                        plate_part_version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    },
                    {
                        name: '特殊采购件1',
                        plate_part_code: '',
                        plate_part_version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    },
                    {
                        name: '特殊采购件2',
                        plate_part_code: '',
                        plate_part_version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    },
                    {
                        name: '特殊采购件3',
                        plate_part_code: '',
                        plate_part_version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    },
                    {
                        name: '在制品',
                        plate_part_code: '',
                        plate_part_version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    },
                    {
                        name: '成品',
                        plate_part_code: '',
                        plate_part_version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    }
                ], //产品影响基础
                Plate_Mold_Costs: '', //总计
                Plate_Amounts: '', //总计
                ugenry: [
                    {
                        id: '0',
                        name: '一般'
                    },
                    {
                        id: '1',
                        name: '紧急'
                    }
                ],
                timeId: null,
                code: '',
                isShowDialog: false,
                RejectType: 1,
                RejectStr1: '',
                RejectStr2: '',
                fileurl:'',
                isVisiblefile: false,
                fileparm: {
                    Code: '',
                    Data_Type: 13,//ECN证明材料
                    Login_Group:'',
                    Login_DB:'',
                    relation_ecr_no: '',
                    Relation_Strategy_No: '',
                },
                FileLists:[],
                FileList:[],
                Login_Group:'',
                Login_DB:'',
                scrollTop:0,
                //实施条目计划负责人是否启用
                setplanuser:0,
                signVisible: false,
                partVisible:false,
                IsLoginDB_MY:'',
                selectData: [],
            };
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if(form.name=='home' && Object.keys(vm.$store.state.sharedParams).length > 0){
                    const data = {...vm.$store.state.sharedParams};
                    let arr = []
                    arr.push({
                        query_Condition: data.code,
                        query_field_name: "ecr_no",
                        query_field_type: "txt",
                        query_sort: "",
                        row_sign: 0
                    })
                    let parm = {
                        PageIndex: vm.PageIndex,
                        PageSize: vm.PageSize,
                        SelectIndex: vm.SelectIndex,
                        Param: arr
                    };
                    vm.$http.urlpost('/Eng/ECN/ECNList', parm, function (res) {
                        if (res.Success == 1) {
                            vm.datajson = res.DataContent;
                            vm.total = res.Totals;
                            vm.DbTbNames = res.DbTbNames;
                            if(vm.datajson.length == 1){
                                setTimeout(() => {
                                    vm.openEdit()
                                    vm.getdlist(data.code, '', '');
                                }, 500);
                            }
                        }
                        vm.loading = false;
                    });
                    vm.$store.commit('clearSharedParams')
                }
                else if((form.name=='wi&iiinfo'||form.name=='wi&iidetail') && Object.keys(vm.$store.state.sharedParams).length > 0){
                    const data = {...vm.$store.state.sharedParams};
                    let arr = []
                    arr.push({
                        query_Condition: data.part_code,
                        query_field_name: "part_code",
                        query_field_type: "txt",
                        query_sort: "",
                        row_sign: 0
                    })
                    arr.push({
                        row_sign:0,
                        query_Condition:"",
                        query_sort:"降序",
                        query_field_type:"date",
                        query_field_name:"create_time"
                    })
                    let parm = {
                        PageIndex: vm.PageIndex,
                        PageSize: vm.PageSize,
                        SelectIndex: vm.SelectIndex,
                        Param: arr
                    };
                    vm.$http.urlpost('/Eng/ECN/ECNList', parm, function (res) {
                        if (res.Success == 1) {
                            vm.datajson = res.DataContent;
                            vm.total = res.Totals;
                            vm.DbTbNames = res.DbTbNames;
                            if(vm.datajson.length == 1){
                                setTimeout(() => {
                                    vm.openEdit()
                                    vm.getdlist(data.code, '', '');
                                }, 500);
                            }
                        }
                        vm.loading = false;
                    });
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        create() {
            console.log('create');

        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        beforeMount() {
            console.log('beforeMount');
            let that = this;
            that.getecnno();
            that.GetALlECNType();
            that.getstagelist();
            that.getecnitem();
            that.getecndep();
            if(that.userData.Login_DB.toLowerCase() !="my"){ 
                that.getecnper();
            }
        },
        mounted() {
            let that = this;
            that.colsort();
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            let parm = {
                Code: that.userData.EmpCode
            }
            if(that.userData.Login_DB.toLowerCase() =="my"){ 
                that.IsLoginDB_MY="my";
            }
            let token = that.userData.token;
            that.Login_Group=that.userData.Login_Group;
            that.Login_DB=that.userData.Login_DB
            that.fileurl = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token;            
            that.$http.urlpost('/Eng/ECN/GetEmpByCode', parm, function (res) {
                if (res.Success == 1) {
                    that.SuperiorName = res.DataContent.Head.SuperiorName
                }
            });
            that.user = that.userData.username;
            that.$limits.dragControllerDiv();
            that.authority();
            //that.intidata();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
            that.setplanuser=Array.methods.getSysConfig('A121');
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ECRViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            // 弹框设置
            // 客户
            showsal() {
                this.$refs.setsal.clearInput(true);
            },
            //头部物料弹框
            showitem() {
                this.$refs.setitem.clearInput(true);
            },
            showitems(ind) {
                console.log(ind);
                this.rowindx = ind.$index;
                this.$refs.setitems.clearInput(true);
            },
            //头接受人
            showgetpe(i) {
                this.rowindx = i;
                this.$refs.setper.clearInput(true);
            },
            //ecn实施计划负责人
            showgetpes(row) {
                this.rowindx = row.$index;
                this.$refs.setpers.clearInput(true);
            },
            showgetpess(ind) {
                this.rowindx = ind;
                this.$refs.setperss.clearInput(true);
            },
            /* 获取客户信息
            customer_id: "CSM"
            customer_name: "上海锐柯"
            index: 6
            shortname: "锐柯" */
            getsal(val) {
                let that=this;
                that.ecnno1 = val.customer_id;
                that.Master.client_name = val.customer_name;
                if(that.userData.Login_DB.toLowerCase() =="my"){ 
                    that.Master.Planner=that.user + '(' + that.userData.EmpCode + ')';
                    that.Master.Audit_Person=that.user + '(' + that.userData.EmpCode + ')';
                    that.Master.Create_Person=that.user + '(' + that.userData.EmpCode + ')';
                    that.Master.Confirm_Person=that.user + '(' + that.userData.EmpCode + ')';

                    that.$http.urlpost('Eng/ECN/GetEcnPartInfo', null, function (res) {
                        if (res.Success == 1) {
                            that.Master.part_code = res.DataContent.part_code;
                            that.Master.part_name = res.DataContent.part_name;
                            that.Master.part_version = res.DataContent.part_version;
                            // console.log("测试222")
                            // that.proyx[6].plate_part_code = res.DataContent.part_code;
                            // that.proyx[6].plate_part_version = res.DataContent.part_version;
                            // that.proyx[7].plate_part_code = res.DataContent.part_code;
                            // that.proyx[7].plate_part_version = res.DataContent.part_version;
                            // console.log("测试333")
                            // that.proyx[6].Plate_Stock_Num=0;                        
                            // that.proyx[7].Plate_Stock_Num=0;
                        }
                    });
                }
            },
            
            handleChange(file, fileList) {
                this.FileList = fileList.slice(-3);
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log('------handleSuccess---', res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(res.Msg);
                } else {
                    that.$message.success(res.Msg);
                    that.loadfiles(that.fileparm)
                }
            },
            lookfiles(val) {
                window.open(val.row.path,"_blank");
            },
            filedel(val){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        if(val.row.exclusively_id == 0){
                            that.FileLists.splice(val.$index, 1)
                        } else {
                            let parm = {
                                ids: val.row.exclusively_id,
                                FilesSrc: val.row.path
                            }
                            that.$http.urlpost('/Basic/ECN/DelItemFileByID', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.loadfiles(that.fileparm);
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 上传
            files(val) {
                let that = this;
                //初始化保存附件参数                
                that.FileLists = [];
                that.fileparm.relation_ecr_no = val.row.relation_ecr_no;
                that.fileparm.Relation_Strategy_No = val.row.Relation_Strategy_No;
                
                // that.FileList.forEach(item => {
                //     if (item.Code == val.row.relation_ecr_no) {
                //         that.FileLists.push(item);
                //     }
                // })
                const key = generatekey(8); // 也可直接指定key let key = 'des';                
                that.fileparm.Login_Group=encryptDes(that.Login_Group,key);
                that.fileparm.Login_DB=encryptDes(that.Login_DB,key);
                that.loadfiles(that.fileparm);
               
            },
            loadfiles(val){
                let that = this;
                //初始化保存附件参数                
                that.FileLists = [];
                 //  查询数据
                 let parm = {
                    relation_ecr_no: val.relation_ecr_no,
                    Relation_Strategy_No:val.Relation_Strategy_No,
                    LangType:  that.$processdata.getLang(),
                }
                that.$http.urlpost('/Basic/ECN/GetEcnFilesLists', parm, function (res) {
                    if (res.Success == 1) {
                        that.FileLists=res.DataContent.FileList;
                    }
                });
                this.isVisiblefile = true;
            },
            /* 获取物料信息
            part_code: "00000001-1"
            part_name: "ghtyty"
            part_version: "A" */
            getitem(val) {
                console.log(val);
                this.Master.part_code = val.part_code;
                this.Master.part_name = val.part_name;
                this.Master.part_version = val.part_version;
                // this.proyx[6].plate_part_code = val.part_code;
                // this.proyx[6].plate_part_version = val.part_version;
                // this.proyx[7].plate_part_code = val.part_code;
                // this.proyx[7].plate_part_version = val.part_version;
                // this.gersum(6, val.part_code, val.part_version, 2);
                // this.gersum(7, val.part_code, val.part_version, 1);
            },
            getitems(val) {
                this.proyx[this.rowindx].plate_part_code = val.part_code;
                this.proyx[this.rowindx].plate_part_version = val.part_version;
                // this.gersum(this.rowindx, val.part_code, val.part_version, 0);
            },
            /* 获取接受人
            code: "01001"
            dept: "董事长"
            index: 7
            name: "张新联" */
            getper(val) {
                if (this.rowindx == 0) {
                    this.Master.ecr_accept_person = val.name + '(' + val.code + ')';
                }
                if (this.rowindx == 1) {
                    this.Master.planner = val.name + '(' + val.code + ')';
                }
                if (this.rowindx == 2) {
                    this.Master.ecr_produce_person = val.name + '(' + val.code + ')';
                }
                if (this.rowindx == 3) {
                    this.Master.ecr_purchase_person = val.name + '(' + val.code + ')';
                }
                this.$forceUpdate();
            },
            getpers(val) {
               
            },
            checkf(e, val) {
                let that = this;
                    
                
            },
            checismustfile(e,val){                             
                let ind = val.$index;
                           },
            copyplandate(){
                //拷贝计划日期
                let that = this
               
            },
            checkfclick(val) {
                console.log(val);
               
            },
            getperss(val) {
                this.ecndep[this.rowindx].remark = val.name + '(' + val.code + ')';
                this.ecndep[this.rowindx].checked = true;
                this.$forceUpdate();
            },
            // gersum(ind, code, ver, typ) {
            //     let that = this;
            //     let parm = {
            //         part_code: code,
            //         part_version: ver,
            //         workProc: typ
            //     };
            //     that.$http.urlpost('Eng/ECN/GetSumOnHand', parm, function (res) {
            //         console.log(res);
            //         if (res.Success == 1) {
            //             that.proyx[ind].Plate_Stock_Num = that.sums(res.DataContent);
            //             that.$forceUpdate();
            //         }
            //     });
            // },
            sums(nums) {
                if (typeof nums == 'number') {
                    // 判断是否为数字类型   数字类型自动  舍0
                    nums = nums.toString(); // 先转成  字符串类型
                    if (nums.indexOf('.') != -1) {
                        // 判断 有无小数点  0 表示 有小数点  -1  表示没有小数点
                        let b = nums.split('.'); // 根据小数点  转换字符串为数组
                        if (b[1].length == 1) {
                            // 判断 有几位小数  如果有一位  加一个0
                            b = b.join('.');
                            b += '0';
                            nums = b;
                        }
                    } else {
                        nums += '.00';
                    }
                } else if (typeof nums == 'string') {
                    // 同理
                    if (nums.indexOf('.') != -1) {
                        let b = nums.split('.');
                        if (b[1].length == 1) {
                            b = b.join('.');
                            b += '0';
                            nums = b;
                        }
                    } else {
                        nums += '.00';
                    }
                }
                return nums;
            },
            //ECNNO下拉选项
            getecnno() {
                let that = this;
                that.$http.urlpost('/Eng/ECN/GetECNNO', {}, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.ecnnolist = res.DataContent;
                        that.ecnno = res.DataContent[0].items;
                    }
                });
            },
            //ECN类型下拉选项
            GetALlECNType() {
                let that = this;
                that.$http.urlpost('/Eng/ECN/GetALlECNType', {}, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.ecntypelist = res.DataContent;
                    }
                });
            },
            //当前阶段下拉选项
            getstagelist() {
                let that = this;
                that.$http.urlpost('Eng/ECN/GetALlECNProductStage', {}, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.ecnstagelist = res.DataContent;
                    }
                });
            },
            //获取实施条目
            getecnitem() {
                let that = this;
            },
            //获取分发部门
            getecndep() {
                let that = this;
                that.$http.urlpost('/Basic/ECN/GetECNDepartmentList', {}, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.ecndep = res.DataContent;
                        that.ecndep.forEach(item => {
                            item.checked = false;
                            item.remark = '';
                        });
                    }
                });
            },
            //获取会签人员
            getecnper() {
                let that = this;
                that.$http.urlpost('/Basic/ECN/GetECNSignatureStrategyList', {}, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.ecnper = res.DataContent;
                        that.ecnper.forEach(item => {
                            item.opinion = null;
                            item.superior_flag = 0;
                            item.opinion_person = item.User_Name;
                            item.opinion_time = null;
                            item.relation_ecr_no = null;
                            item.relation_signature_strategy_no = item.signature_strategy_no;
                            item.opinion_status = '-1';
                            item.role_name = item.Role_Name;
                            item.user_name = item.User_Name;
                        });
                    }
                });
            },
            //分发部门
            ecndeps() {
                this.$forceUpdate();
            },
            //强制关闭
            closeqz() {
                let that = this;
                that.$XModal.confirm(that.$t('getapi[8725]')).then(type => {//确认强制关闭？
                    if (type == 'confirm') {
                        let parm = that.Master;
                        parm.ecr_no = that.ecnno + '-ECR-' + that.ecnno1 + '-' + that.ecnno2;
                        parm.ecr_accept_time = parm.ecr_accept_time != '' ? parm.ecr_accept_time : null;
                        parm.client_accept_time = parm.client_accept_time != '' ? parm.client_accept_time : null;
                        parm.create_time = parm.create_time != '' ? parm.create_time : null;
                        parm.audit_time = parm.audit_time != '' ? parm.audit_time : null;
                        parm.confirm_time = parm.confirm_time != '' ? parm.confirm_time : null;
                        parm.ecr_produce_time = parm.ecr_produce_time != '' ? parm.ecr_produce_time : null;
                        parm.ecr_purchase_time = parm.ecr_purchase_time != '' ? parm.ecr_purchase_time : null;
                        parm.ecr_close_time = parm.ecr_close_time != '' ? parm.ecr_close_time : null;
                        parm.modify_time = parm.modify_time != '' ? parm.modify_time : null;
                        console.log(JSON.stringify(parm));
                        that.loading = true;
                        that.$http.urlpost('/Eng/ECR/CloseECR', parm, function (res) {
                            console.log(res);
                            if (res.Success == 1) {
                                that.$message.success(that.$t('getapi[4230]'));//关闭成功
                                that.intidata();
                                that.getdlist(parm.ecr_no, '', '');
                            }
                        });
                    }
                });
            },
            //会签弹框
            hq(e) {
                this.sign = e.row;
                this.dialogVisible = true;
            },
            hqbtn(i) {
                let that = this;
                let parm = {
                    relation_ecr_no: that.sign.relation_ecr_no,
                    relation_signature_strategy_no: that.sign.relation_signature_strategy_no,
                    opinion_person: that.sign.opinion_person,
                    opinion: that.sign.opinion,
                    opinion_time: that.getnewdate(),
                    role_name: that.sign.role_name,
                    user_name: that.sign.user_name,
                    opinion_status: that.sign.opinion_status
                };
                if (that.sign.opinion) {
                    if (i == 0) {
                        parm.opinion_status = 1;
                        that.$http.urlpost('Eng/ECR/btnSignOKClick', parm, function (res) {
                            console.log(res);
                            if (res.Success == 1) {
                                that.$message.success(that.$t('getapi[8726]'));
                                that.intidata();
                                that.getdlist(that.Master.ecr_no, '', '');
                                that.dialogVisible = false;
                            }
                        });
                    } else {
                        parm.opinion_status = 0;
                        that.$http.urlpost('Eng/ECR/btnSignNoClick', parm, function (res) {
                            console.log(res);
                            if (res.Success == 1) {
                                that.$message.success(that.$t('getapi[8726]'));
                                that.intidata();
                                that.getdlist(that.Master.ecr_no, '', '');
                                that.dialogVisible = false;
                            }
                        });
                    }
                } else {
                    that.$message.error(that.$t('getapi[8727]'));
                }
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6125]"),this.$t("getapi[18]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                that.btn.colse = false;
                if (that.$limits.authority('plv4', 595, 1) == 1) {
                    that.btn.colse = true
                } else {
                    that.btn.colse = false
                }

                //管理界面
                if (that.$limits.authority('plv2', 595, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 595, 1) == 2) {
                    if (that.$limits.authority('plv3', 595, 1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 595, 1) == 1) {
                        //编辑级
                        if (!that.$limits.fnIsEmpty(that.Master.ecr_no)) {
                            if (that.Master.ecr_status == '0' || that.Master.ecr_status == '1' || that.Master.ecr_status == '2') {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                    if (that.$limits.authority('plv3', 595, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.Master.ecr_no)) {
                            if (that.Master.ecr_status == '0') {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,del');
                            } else if(that.Master.ecr_status == '1' || that.Master.ecr_status == '2'){
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                }
                else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    if (that.$limits.authority('plv2', 595, 1) > 0) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                    }
                }

                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.rowdel = false;
                that.btn.delsign= false;
                if(that.Master.ecr_status==0){
                    that.btn.delsign=true;
                }
                that.btn.delpart= false;
                if(that.Master.ecr_status==0){
                    that.btn.delpart=true;
                }
                
                if (that.selectIDData.length > 0) {
                    if (that.Master.ecr_status == '0') {
                        that.btn.rowdel = true;
                    }
                }
                that.btn.implement = false
                if (that.$limits.authority('plv4', 344, 1) > 0) {
                    that.btn.implement = true
                }
                if (that.userData.username == that.SuperiorName) {
                    that.btn.implement = true
                }
            },
            //表格背景
            tableRowClassName({row, rowIndex}) {
                //console.log(row.enable_flag);
                if (row.enable_flag == '是') {
                    return 'warning-row';
                }
                if (row.ecr_status == '不可用') {
                    return 'dark-row';
                }
            },
            tableRowClassNameRight({row, rowIndex}) {
                row.index = rowIndex;
            },
            //获取查询条件
            serclick(val) {
                console.log(val);
                this.queryData = val;
                this.PageIndex = 1;
                this.intidata();
            },

            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('ecnlist',val)
                this.intidata();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
            },

            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                console.log(parm);
                that.$http.urlpost('/Eng/ECR/ECRList', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                    that.loading = false;
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndex)
                    });
                });
            },
            //获取详细
            getdlist(id, name, where) {
                let that = this;
                let parm = {
                    Code: id
                };
                that.Type = 0;
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Eng/ECR/ECRInfo', parm, function (res) {
                    loadingInstance.close()
                    if (res.Success == 1) {
                        that.isedit = 0;
                        that.Master= res.DataContent.Master;                     
                        that.SignList = res.DataContent.SignList;                        
                        let reg = /^(\w+)[-ECR-]{5}(.*)[-]{1}(\d+)$/
                        let enid = reg.exec(res.DataContent.Master.ecr_no)
                        console.log('测试：' + JSON.stringify(enid))
                        that.ecnno = enid[1];
                        that.ecnno1 = enid[2];
                        that.ecnno2 = enid[3];
                        // let Department = res.DataContent.Master.Department.split('|');
                        // that.ecndep.forEach(item => {
                        //     item.checked = false;
                        //     item.remark = '';
                        //     Department.forEach(items => {
                        //         let itms = items.split('{');
                        //         if (item.Department_Name == itms[0]) {
                        //             item.checked = true;
                        //             item.remark = itms[1].replace('}', '');
                        //         }
                        //     });
                        // });
                        // ECN会签
                        that.ecnper = res.DataContent.SignList ;
                        that.ecnper.forEach(item => {
                            if (item.opinion_status == '未会签') {
                                item.opinion_status = -1;
                            }
                            if (item.opinion_status == '不同意') {
                                item.opinion_status = 0;
                            }
                            if (item.opinion_status == '同意') {
                                item.opinion_status = 1;
                            }
                        });
                    }
                    that.authority();
                });

            },
            onEditorChange(val){
                let that = this
                that.Master.ecr_description = val
            },
            
            // 驳回
            reject(type){
                let that = this
                if(type == 1){
                    that.RejectStr1 = ''
                } else {
                    that.RejectStr2 = ''
                }
                that.RejectType = type
                that.isShowDialog = true
            },
            confirmReject(type){
                let that = this
                let parm = that.Master
                if(type == 1){
                    parm.RejectStr1 = that.RejectStr1
                    parm.RejectStr2 = ''
                } else if(type == 2){
                    parm.RejectStr1 = ''
                    parm.RejectStr2 = that.RejectStr2
                }
                that.loading = true;
                that.$http.urlpost('/Eng/ECN/RejectS0', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata();
                        that.getdlist(that.Master.ecr_no, '', '');
                        that.isShowDialog = false;
                    } else {
                        that.getdlist(that.Master.ecr_no, '', '');
                    }
                    that.loading = false;
                });
            },
            //操作状态保存
            savas(sta) {
                let that = this
                this.$XModal.confirm(that.$t('getapi[8596]')).then(type => {//'确定要执行嘛'
                    if (type == 'confirm') {
                        console.log(sta);
                        switch (sta) {
                            case 1:
                                this.Master.create_time = this.getnewdate();
                                break;
                            case 2:
                                this.Master.Planner_Affirm = this.getnewdate();
                                break;
                            case 3:
                                this.Master.audit_time = this.getnewdate();
                                break;
                            case 4:
                                this.Master.confirm_time = this.getnewdate();
                                break;
                            case 8:
                                this.Master.ecr_produce_time = this.getnewdate();
                                break;
                            case 9:
                                this.Master.ecr_purchase_time = this.getnewdate();
                                break;
                        }
                        this.Type = sta;
                        this.isedit = 0;
                        if (sta < 8) {
                            this.Master.ecr_status = sta;
                        }
                        this.sava();
                    }
                });
            },
            // 保存数据
            sava() {
                let that = this;
                if(that.ecnno1 == ''){
                    that.$message.warning(that.$t('getapi[9879]'))//'客户不能为空'
                    return false
                }
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                let loadingInstance = Loading.service(Common.maskoption1);
                let parm = {
                    Type: that.Type,
                    isedit: that.isedit,
                    SignList: that.ecnper,
                    Master: that.Master,
                };
                parm.Master.Department = ''
                that.ecndep.forEach(item => {
                    if (item.checked) {
                        parm.Master.Department += item.Department_Name + '{' + item.remark + '}|';
                    }
                });
                parm.Master.ecr_no = that.ecnno + '-ECR-' + that.ecnno1 + '-' + that.ecnno2;
                parm.Master.ecr_accept_time = parm.Master.ecr_accept_time != '' ? parm.Master.ecr_accept_time : null;
                parm.Master.client_accept_time = parm.Master.client_accept_time != '' ? parm.Master.client_accept_time : null;
                parm.Master.create_time = parm.Master.create_time != '' ? parm.Master.create_time : null;
                parm.Master.audit_time = parm.Master.audit_time != '' ? parm.Master.audit_time : null;
                parm.Master.confirm_time = parm.Master.confirm_time != '' ? parm.Master.confirm_time : null;
                parm.Master.ecr_produce_time = parm.Master.ecr_produce_time != '' ? parm.Master.ecr_produce_time : null;
                parm.Master.ecr_purchase_time = parm.Master.ecr_purchase_time != '' ? parm.Master.ecr_purchase_time : null;
                parm.Master.ecr_close_time = parm.Master.ecr_close_time != '' ? parm.Master.ecr_close_time : null;
                parm.Master.modify_time = parm.Master.modify_time != '' ? parm.Master.modify_time : null;
                //产品影响
                parm.Master.plate_part_code_1 = that.proyx[0].plate_part_code;
                parm.Master.plate_part_version_1 = that.proyx[0].plate_part_version;
                parm.Master.plate_onway_num_1 = that.proyx[0].plate_onway_num;
                parm.Master.plate_stock_num_1 = that.proyx[0].plate_stock_num;
                parm.Master.plate_deal_with_1 = that.proyx[0].plate_deal_with;
                parm.Master.plate_deal_with_1_0 = that.proyx[0].procurement_deal_with;
                parm.Master.plate_price_1 = that.proyx[0].plate_price;
                parm.Master.plate_mold_cost_1 = that.proyx[0].plate_mold_cost;
                parm.Master.plate_amount_1 = that.proyx[0].plate_amount;
                parm.Master.plate_bear_1 = that.proyx[0].plate_bear;
                parm.Master.plate_part_code_2 = that.proyx[1].plate_part_code;
                parm.Master.plate_part_version_2 = that.proyx[1].plate_part_version;
                parm.Master.plate_onway_num_2 = that.proyx[1].plate_onway_num;
                parm.Master.plate_stock_num_2 = that.proyx[1].plate_stock_num;
                parm.Master.plate_deal_with_2 = that.proyx[1].plate_deal_with;
                parm.Master.plate_deal_with_2_0 = that.proyx[1].procurement_deal_with;
                parm.Master.plate_price_2 = that.proyx[1].plate_price;
                parm.Master.plate_mold_cost_2 = that.proyx[1].plate_mold_cost;
                parm.Master.plate_amount_2 = that.proyx[1].plate_amount;
                parm.Master.plate_bear_2 = that.proyx[1].plate_bear;
                parm.Master.plate_part_code_3 = that.proyx[2].plate_part_code;
                parm.Master.plate_part_version_3 = that.proyx[2].plate_part_version;
                parm.Master.plate_onway_num_3 = that.proyx[2].plate_onway_num;
                parm.Master.plate_stock_num_3 = that.proyx[2].plate_stock_num;
                parm.Master.plate_deal_with_3 = that.proyx[2].plate_deal_with;
                parm.Master.plate_deal_with_3_0 = that.proyx[2].procurement_deal_with;
                parm.Master.plate_price_3 = that.proyx[2].plate_price;
                parm.Master.plate_mold_cost_3 = that.proyx[2].plate_mold_cost;
                parm.Master.plate_amount_3 = that.proyx[2].plate_amount;
                parm.Master.plate_bear_3 = that.proyx[2].plate_bear;
                parm.Master.procurement_part_code_1 = that.proyx[3].plate_part_code;
                parm.Master.procurement_part_version_1 = that.proyx[3].plate_part_version;
                parm.Master.procurement_onway_num_1 = that.proyx[3].plate_onway_num;
                parm.Master.procurement_stock_num_1 = that.proyx[3].plate_stock_num;
                parm.Master.procurement_deal_with_1 = that.proyx[3].plate_deal_with;
                parm.Master.procurement_deal_with_1_0 = that.proyx[3].procurement_deal_with;
                parm.Master.procurement_price_1 = that.proyx[3].plate_price;
                parm.Master.procurement_mold_cost_1 = that.proyx[3].plate_mold_cost;
                parm.Master.procurement_amount_1 = that.proyx[3].plate_amount;
                parm.Master.procurement_bear_1 = that.proyx[3].plate_bear;
                parm.Master.procurement_part_code_2 = that.proyx[4].plate_part_code;
                parm.Master.procurement_part_version_2 = that.proyx[4].plate_part_version;
                parm.Master.procurement_onway_num_2 = that.proyx[4].plate_onway_num;
                parm.Master.procurement_stock_num_2 = that.proyx[4].plate_stock_num;
                parm.Master.procurement_deal_with_2 = that.proyx[4].plate_deal_with;
                parm.Master.procurement_deal_with_2_0 = that.proyx[4].procurement_deal_with;
                parm.Master.procurement_price_2 = that.proyx[4].plate_price;
                parm.Master.procurement_mold_cost_2 = that.proyx[4].plate_mold_cost;
                parm.Master.procurement_amount_2 = that.proyx[4].plate_amount;
                parm.Master.procurement_bear_2 = that.proyx[4].plate_bear;
                parm.Master.procurement_part_code_3 = that.proyx[5].plate_part_code;
                parm.Master.procurement_part_version_3 = that.proyx[5].plate_part_version;
                parm.Master.procurement_onway_num_3 = that.proyx[5].plate_onway_num;
                parm.Master.procurement_stock_num_3 = that.proyx[5].plate_stock_num;
                parm.Master.procurement_deal_with_3 = that.proyx[5].plate_deal_with;
                parm.Master.procurement_deal_with_3_0 = that.proyx[5].procurement_deal_with;
                parm.Master.procurement_price_3 = that.proyx[5].plate_price;
                parm.Master.procurement_mold_cost_3 = that.proyx[5].plate_mold_cost;
                parm.Master.procurement_amount_3 = that.proyx[5].plate_amount;
                parm.Master.procurement_bear_3 = that.proyx[5].plate_bear;
                // parm.Master.part_code = that.proyx[6].plate_part_code;
                // parm.Master.part_version = that.proyx[6].plate_part_version;
                parm.Master.making_onway_num = that.proyx[6].plate_onway_num;
                parm.Master.making_stock_num = that.proyx[6].plate_stock_num;
                parm.Master.making_deal_with = that.proyx[6].plate_deal_with;
                parm.Master.making_deal_with_0 = that.proyx[6].procurement_deal_with;
                parm.Master.making_price = that.proyx[6].plate_price;
                parm.Master.making_mold_cost = that.proyx[6].plate_mold_cost;
                parm.Master.making_amount = that.proyx[6].plate_amount;
                parm.Master.making_bear = that.proyx[6].plate_bear;
                // parm.Master.part_code = that.proyx[7].plate_part_code;
                // parm.Master.part_version = that.proyx[7].plate_part_version;
                parm.Master.product_onway_num = that.proyx[7].plate_onway_num;
                parm.Master.product_stock_num = that.proyx[7].plate_stock_num;
                parm.Master.product_deal_with = that.proyx[7].plate_deal_with;
                parm.Master.product_deal_with_0 = that.proyx[7].procurement_deal_with;
                parm.Master.product_price = that.proyx[7].plate_price;
                parm.Master.product_mold_cost = that.proyx[7].plate_mold_cost;
                parm.Master.product_amount = that.proyx[7].plate_amount;
                parm.Master.product_bear = that.proyx[7].plate_bear;
                console.log(JSON.stringify(parm));
                that.loading = true;
                that.SignList.forEach(itme => {
                    itme.user_name_backup = itme.user_name_backup == null ? '' : itme.user_name_backup;
                    itme.opinion_time = itme.opinion_time != '' ? itme.opinion_time : null;
                });
              
                that.$http.urlpost('Eng/ECR/SaveECR', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.intidata();
                        that.getdlist(res.UniqueNum, '', '');
                        that.editvisi = false;
                    }
                    that.loading = false;
                });
                loadingInstance.close()
                that.$refs.SetBtn.SetOneBtnEnable('save', true);
            },

            //行编辑
            edits(e) {
                let that = this;
                if(that.code == e.ecr_no){
                    return
                }
                that.timeId = setTimeout(() => {
                    that.editf = false;
                    that.code = e.ecr_no;
                    that.getdlist(that.code, '', '');
                }, 100);
            },
            // 编辑
            edit(jsd) {
                console.log(jsd);
                let that = this;
                that.editvisi = true;
                that.editf = false;
                that.isedit = 0;
                let code = jsd.row.ecr_no;
                that.getdlist(code, '', '');
            },

            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = val;
            },
            handleSelectionChange_Ecnper(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
            },
            imp() {
                let item = {
                    //label: '工艺导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/3',
                    url: '/exp/3',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/3'});
                this.$store.commit('selectMenu', item);
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    code: that.Master.ecr_no
                };
                that.$http.urlpost('/Eng/ECR/DelECRByID', parm, function (res) {
                    if(res.Success==1){
                        that.intidata();
                        that.confirmAdd();
                        that.$message.success(that.$t('getapi[659]'));
                    }
                });
            },
            // 删除
            del(jsd) {
                // this.ids = jsd.row.ecr_no + ',';
                this.delf();
            },
            //批量删除
            delall() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该ECN数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            
            //获取当前时间
            getnewdate() {
                var date = new Date();
                var y = date.getFullYear();
                var m = date.getMonth() + 1;
                m = m < 10 ? '0' + m : m;
                var d = date.getDate();
                d = d < 10 ? '0' + d : d;
                var h = date.getHours();
                var mm = date.getMinutes();
                var ss = date.getSeconds();
                h = h < 10 ? '0' + h : h;
                mm = mm < 10 ? '0' + mm : mm;
                ss = ss < 10 ? '0' + ss : ss;
                return y + '/' + m + '/' + d + ' ' + h + ':' + mm + ':' + ss;
            },
            // 新增
            add() {
                let that = this
                that.openEdit()
                that.confirmAdd()
            },
            confirmAdd(){
                let that = this;
                that.isedit = 1;
                that.Type = 0;
                let datetime = Common.methods.getDatetime();
                that.getecnitem();
                if(that.userData.Login_DB.toLowerCase() !="my"){ 
                    that.getecnper();
                }
                that.ecnno = that.ecnnolist[0].items;
                that.ecnno1 = '';
                that.ecnno2 = '';
                that.Master= {
                    ecr_no: '',
                    part_code: '',
                    part_version: '',
                    ecr_status: '0',
                    ecr_source: '',
                    client_name: '',
                    product_name: '',
                    client_ecr_no: '',
                    ecr_type_code: '',
                    product_stage_code: '',
                    ecr_urgency: '',
                    ecr_description: '',
                    ecr_accept_time: null,
                    ecr_accept_person: '',
                    client_confirm: '',
                    annex_drawing_num: '',
                    annex_wi_num: '',
                    annex_other_num: '',
                    plate_part_code_1: '',
                    plate_part_version_1: '',
                    plate_onway_num_1: '',
                    plate_stock_num_1: '',
                    plate_deal_with_1: '',
                    plate_price_1: '',
                    plate_mold_cost_1: '',
                    plate_amount_1: '',
                    plate_bear_1: '',
                    plate_part_code_2: '',
                    plate_part_version_2: '',
                    plate_onway_num_2: '',
                    plate_stock_num_2: '',
                    plate_deal_with_2: '',
                    plate_price_2: '',
                    plate_mold_cost_2: '',
                    plate_amount_2: '',
                    plate_bear_2: '',
                    plate_part_code_3: '',
                    plate_part_version_3: '',
                    plate_onway_num_3: '',
                    plate_stock_num_3: '',
                    plate_deal_with_3: '',
                    plate_price_3: '',
                    plate_mold_cost_3: '',
                    plate_amount_3: '',
                    plate_bear_3: '',
                    procurement_part_code_1: '',
                    procurement_part_version_1: '',
                    procurement_onway_num_1: '',
                    procurement_stock_num_1: '',
                    procurement_deal_with_1: '',
                    procurement_price_1: '',
                    procurement_mold_cost_1: '',
                    procurement_amount_1: '',
                    procurement_bear_1: '',
                    procurement_part_code_2: '',
                    procurement_part_version_2: '',
                    procurement_onway_num_2: '',
                    procurement_stock_num_2: '',
                    procurement_deal_with_2: '',
                    procurement_price_2: '',
                    procurement_mold_cost_2: '',
                    procurement_amount_2: '',
                    procurement_bear_2: '',
                    procurement_part_code_3: '',
                    procurement_part_version_3: '',
                    procurement_onway_num_3: '',
                    procurement_stock_num_3: '',
                    procurement_deal_with_3: '',
                    procurement_price_3: '',
                    procurement_mold_cost_3: '',
                    procurement_amount_3: '',
                    procurement_bear_3: '',
                    making_onway_num: '',
                    making_stock_num: '',
                    making_deal_with: '',
                    making_price: '',
                    making_mold_cost: '',
                    making_amount: '',
                    making_bear: '',
                    product_onway_num: '',
                    product_stock_num: '',
                    product_deal_with: '',
                    product_price: '',
                    product_mold_cost: '',
                    product_amount: '',
                    product_bear: '',
                    planner: '',
                    planner_remark: '',
                    planner_affirm: '',
                    original_price: '',
                    current_price: '',
                    client_accept: '',
                    client_accept_time: null,
                    create_person: this.user + '(' + that.userData.EmpCode + ')',
                    create_time: null,
                    audit_person: '',
                    audit_time: null,
                    confirm_person: '',
                    confirm_time: null,
                    ecr_produce_person: '',
                    ecr_produce_time: '',
                    ecr_purchase_person: '',
                    ecr_purchase_time: null,
                    ecr_notes: '',
                    department: '',
                    ecr_close_time: null,
                    ecr_close_person: this.user + '(' + that.userData.EmpCode + ')',
                    modify_person: '',
                    modify_time: new Date(),
                    plate_deal_with_1_0: '',
                    plate_deal_with_2_0: '',
                    plate_deal_with_3_0: '',
                    procurement_deal_with_1_0: '',
                    procurement_deal_with_2_0: '',
                    procurement_deal_with_3_0: '',
                    making_deal_with_0: '',
                    product_deal_with_0: '',
                    routingstr: '',
                    new_flag: '',
                    itemvernum: '',
                    rejectstr1: '',
                    rejectstr2: ''
                };
                that.PartLists=[],
                this.editvisi = true;
                this.editf = true;
                that.code = ''
                that.$http.urlpost('/Eng/ECN/GetSupercodeInfo', '', function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent.length == 2){
                            if(res.DataContent[0] != null){
                                that.Master.Audit_Person = res.DataContent[0].name + '(' + res.DataContent[0].code + ')'
                            }
                            if(res.DataContent[1] != null){
                                that.Master.Confirm_Person = res.DataContent[1].name + '(' + res.DataContent[1].code + ')'
                            }
                        }
                    }
                });
                this.authority(2);
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'ECRViewInfo');
            },
            // 刷新
            reflash() {
                let that = this;
                that.intidata(); //刷新左边
                //刷右边
                if (!that.$limits.fnIsEmpty(that.Master.ecr_no)) {
                    that.getdlist(that.Master.ecr_no, '', '');
                } else {
                    //清空右边
                    that.confirmAdd();
                }
            },
            //弹出框关闭前提示
            closemodel(e) {
                let that = this
                this.$confirm(that.$t('getapi[3655]'), that.$t('getapi[194]'), {//'数据已发生变更是否保存后关闭?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                    })
                    .catch(() => {
                    });
            },
            //导出·
            exp() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ECRViewInfo",
                    fromname: that.$t('getapi[13042]'),
                    SelectIndex: that.SelectIndex,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },

            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit() {
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            show(ev, row) {
                let that = this;
                that.edit(row);
            },
            shows(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = this.datajson[index - 1];
                    this.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = this.datajson[index + 1];
                    this.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    let result = this.datajson.findIndex(item => item.ecr_no === val.ecr_no);
                    this.indf = result;
                    let fsd = document.getElementsByClassName('fsd');
                    fsd[result].focus();
                    this.currentRow = val;
                }
            },
            // 刷新统计信息
            refreshView() {
                let that = this
                that.$http.urlpost('/Eng/ECN/DelayPerson', '', function (res) {
                    if (res.Success == 1) {
                        that.intidata()
                    }
                });
            },
            // 选择审核人和批准人
            selectEmployee(val){
                let that = this
                that.employeeType = val
                that.$refs.employee.clearInput(true);
            },
            getEmployee(data){
                let that = this
                console.log(data)
                if(that.employeeType == 1){
                    that.Master.Audit_Person =  data.name + '(' + data.code + ')'
                } else {
                    that.Master.Confirm_Person = data.name + '(' + data.code + ')'
                }
            },
            addpart(val){                
                let that = this;
                that.partVisible = true;
                that.$refs.setpartlist.clearInput(that.partVisible, null);
            },            
            getPartlist(data){
                let that = this;
                let arr = data.filter(item => {
                    return that.PartLists.every(item2 => {
                        return item.part_code != item2.part_code;
                    });
                });
                data=arr;
                for (let i = 0; i < data.length; i++) {
                        that.PartLists = [
                            ...that.PartLists,
                            {
                                exclusively_id:0,
                                part_code:data[i].part_code,
                                part_version:data[i].part_version,
                            }
                        ];
                    }
            },
            delpart() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            LangType: that.$processdata.getLang(),
                            Lists: []
                        };
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.PartLists.splice(that.selectData[i].index, 1);
                            if (that.selectData[i].exclusively_id!=0) {
                                let datatmp = {
                                    relation_ecr_no: that.selectData[i].relation_ecr_no,
                                    exclusively_id: that.selectData[i].exclusively_id,
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        
                        if (parm.Lists.length > 0) {
                            that.btn.delpart = false
                            that.$http.urlpost('/Eng/ECN/DelEcnPart', parm, function (res) {
                                that.btn.delpart = true
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            addSign(val){
                let that = this;
                that.signVisible = true;
                that.$refs.setsignlist.clearInput(that.signVisible, null);
            },
            delline() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            LangType: that.$processdata.getLang(),
                            Lists: []
                        };
                        console.log(that.selectData);
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.ecnper.splice(that.selectData[i].index, 1);
                            if (that.selectData[i].isadd==0) {
                                let datatmp = {
                                    relation_ecr_no: that.selectData[i].relation_ecr_no,
                                    relation_signature_strategy_no: that.selectData[i].relation_signature_strategy_no,
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        
                        if (parm.Lists.length > 0) {
                            that.btn.delsign = false
                            that.$http.urlpost('/Eng/ECN/DelSignature', parm, function (res) {
                                that.btn.delsign = true
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getdlist(that.Master.ecr_no, '', '');
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            getSignlist(data){
                let that = this;
                let arr = data.filter(item => {
                    return that.ecnper.every(item2 => {
                        return item.signature_strategy_no != item2.relation_signature_strategy_no ;
                    });
                });
                data=arr;
                for (let i = 0; i < data.length; i++) {
                        that.ecnper = [
                            ...that.ecnper,
                            {
                                opinion : null,
                                superior_flag : 0,
                                opinion_person : data[i].User_Name,
                                opinion_time : null,
                                relation_ecr_no : null,
                                relation_signature_strategy_no : data[i].signature_strategy_no,
                                opinion_status : '-1',
                                role_name :data[i].Role_Name,
                                user_name : data[i].User_Name,
                                iasdd:1,  
                            }
                        ];
                    }
            }
        }
    };
</script>
<style scoped lang="less">
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 20px;
                min-width: 70px;
                text-align: left;
                line-height: 20px;
                display: inline-block;
                margin-right: 5px;
            }
        }
    }

    .boxs {
        width: 100%;
        min-width: 840px;
    }

    .boxs > div {
        width: 30%;
        display: inline-block;
        white-space: nowrap;
        line-height: 30px;
    }

    .boxs > div > label.el-checkbox {
        min-width: 100px;
    }

    .box .bbl span {
        min-width: 0 !important;
    }

    .quill-editor.myQuillEditor {
        /*height: 400px;*/
        overflow-y: auto;
    }

    .bred > input {
        background: red;
        color: #fff;
    }
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
        }
    }
</style>
